import React, { useEffect, useRef, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

const Privacy = () => {
    const navigate = useNavigate();
    return (
        <div className='w-full jana-background-contact text-200'>
            <div className='flex flex-column m-auto w-full p-3 pb-8 lg:w-7 text-shadow'>
                <div className='mb-3'>
                    
                    <h1>Privacy Policy</h1>
                    <p>Last Updated: 06.11.2024</p>

                    <p>'Jana Pelikan' is committed to protecting and respecting your privacy. This Privacy Policy explains how we collect, use, and protect your personal data in compliance with the General Data Protection Regulation (GDPR). This policy applies solely to the information collected through our website, janapelikan.com.</p>

                    {/*<h2>1. Data Controller</h2>
                    <p>The data controller responsible for your personal data is:</p>
                    <p>
                        [Company Name] <br />
                        [Address] <br />
                        [Email Address]
                    </p>*/}

                    <h2>1. Information We Collect</h2>
                    <p>We only collect personal data when you submit it to us through our contact form. The information collected may include:</p>
                    <ul>
                        <li><strong>Name</strong></li>
                        <li><strong>Email Address</strong></li>
                        <li><strong>Message Content</strong></li>
                    </ul>
                    <p>This data is collected solely to respond to your inquiries and provide support.</p>

                    <h2>2. Purpose and Legal Basis for Processing</h2>
                    <p>We collect and process your personal data for the following purposes:</p>
                    <ul>
                        <li><strong>Responding to Your Inquiries</strong>: We use the data you provide to answer your questions and respond to your requests.</li>
                        <li><strong>Improving Our Services</strong>: We may analyze the inquiries we receive to improve the functionality of our website.</li>
                    </ul>
                    <p>The legal basis for processing your data is <strong>legitimate interest</strong> (Article 6(1)(f) of the GDPR), as it allows us to respond to inquiries and improve our services.</p>

                    <h2>3. How We Share Your Data</h2>
                    <p>We do not share your personal data with third parties, except as necessary to comply with legal obligations or to protect our rights.</p>

                    <h2>4. Data Retention</h2>
                    <p>We will retain your personal data only as long as necessary to fulfill the purposes for which it was collected, or as required by applicable laws and regulations. Generally, we will delete your data within 12 months after the last contact unless a longer retention period is required by law.</p>

                    <h2>5. Your Rights</h2>
                    <p>Under the GDPR, you have the following rights:</p>
                    <ul>
                        <li><strong>Right to Access</strong>: You can request access to your personal data.</li>
                        <li><strong>Right to Rectification</strong>: You can ask us to correct any inaccurate data.</li>
                        <li><strong>Right to Erasure</strong>: You can request that we delete your data, subject to legal limitations.</li>
                        <li><strong>Right to Restrict Processing</strong>: You can ask us to limit the processing of your data in certain circumstances.</li>
                        <li><strong>Right to Data Portability</strong>: You have the right to receive your data in a structured, commonly used format.</li>
                        <li><strong>Right to Object</strong>: You can object to our processing of your data based on legitimate interests.</li>
                    </ul>
                    <p>To exercise any of these rights, please contact us at [Email Address].</p>

                    <h2>6. Data Security</h2>
                    <p>We take data security seriously and use appropriate measures to protect your personal data against unauthorized access, disclosure, alteration, or destruction. Our security measures are regularly reviewed to ensure the safety of your data.</p>

                    <h2>7. Changes to This Privacy Policy</h2>
                    <p>We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. We encourage you to review this page periodically for any changes.</p>

                    <h2>8. Contact Us</h2>
                    <p>If you have any questions about this Privacy Policy or our data practices, please contact us at using our contact form on this website.</p>

                </div>
            </div>
        </div>
    );
};

export default Privacy;
